const CartActionTypes = {
    TOOGGLE_CART: "TOOGGLE_CART",
    ADD_ITEM: "ADD_ITEM",
    CLEAR_ITEM_FROM_CART: "CLEAR_ITEM_FROM_CART",
    REMOVE_ITEM: "REMOVE_ITEM"
};

export default CartActionTypes;